import clsx from 'clsx';
import './badge.css';

const SharedBadge = ({ text, icon = null, variant, size = 'sm', className = '', customColor = '' }) => {
  const isHexColor = customColor.startsWith('#');
  const variantStyles = {
    primary: 'badge-primary',
    primaryLight: 'badge-primary-light',
    secondary: 'badge-secondary',
    tertiary: 'badge-tertiary',
    quaternary: 'badge-quaternary',
    warning: 'badge-warning',
    error: 'badge-error',
    custom: isHexColor ? '' : customColor,
  }[variant];

  const sizeStyles = {
    xs: 'text-xs px-1 py-1',
    sm: 'text-sm px-4 py-1',
    md: 'text-base px-6 py-2',
    lg: 'text-lg px-5 py-3',
  }[size];

  const style =
    variant === 'custom' && isHexColor ? { backgroundColor: customColor, color: '#fff' } : undefined;

  return (
    <span
      className={clsx('badge flex items-center px-3 py-1/.5', variantStyles, sizeStyles, className)}
      style={style}
    >
      {icon && icon}
      {text}
    </span>
  );
};

export default SharedBadge;
